import './OrdersList.scss';

import React from 'react';

import ListSort from '@/ebat/components/blocks/ListSort/ListSort';
import Order from '@/ebat/components/blocks/Orders/Order/Order';
import SortOptions from '@/ebat/constants/sort';

import {
  OrdersListDefaultProps,
  OrdersListPropTypes,
} from './OrdersList.proptypes';

const OrdersList = ({ isDisabled, handleSort, orders, sorts }) => {
  const { ORDERS_LIST_SORT } = SortOptions();
  return (
    <div className="orders-list">
      <ListSort
        className="orders-list__sort"
        context="orders-list-sort"
        disabled={isDisabled.disabled}
        dynamicOptions={sorts}
        handleSort={handleSort}
        isLoading={isDisabled.loading}
        staticOptions={ORDERS_LIST_SORT}
      />
      <ul className="orders-list__items" data-qa-id="orders-list-items">
        {orders.map((order) => (
          <li
            className="orders-list__item"
            key={`order-${order.id}`}
            data-qa-item-id={order.id}
            data-qa-id="orders-list-item"
          >
            <Order
              date={order.created_at}
              delivered={order.delivered}
              deliveryNotes={order.delivery_notes}
              disabled={isDisabled.disabled}
              hasInvoice={order.has_invoice}
              id={order.id}
              isLoading={isDisabled.loading}
              isShippingAvailable={order.is_shipping_available}
              number={order.number}
              origin={order.origin}
              reference={order.reference}
              shippingType={order.shipping_type}
              status={order.status}
              totalDelivered={order.total_delivered}
              totalLeft={order.amount_total_left}
              totalRaw={order.amount_total_raw}
              unreadHistory={order.unread_history}
              updated={order.unread_history}
              worksite={order.worksite?.label}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

OrdersList.defaultProps = {
  ...OrdersListDefaultProps,
};

OrdersList.propTypes = {
  ...OrdersListPropTypes,
};

export default OrdersList;
